/** Размеры элементов нотификации */
export const SIZES = {
    icon: 24,
    iconGap: 4,

    dtmfCircle: 22,
    dtmfCircleGap: 3,

    containerHeight: 40,
    containerBorderRadius: 12,
    containerPaddingX: 16,
    containerPaddingY: 8,

    separatorWidth: 1,
    separatorHeight: 16,
    separatorMarginX: 8,

    rowGap: 14,
    notificationGap: 24,
    paddingBottom: 61,
    paddingBottomAloneScreen: 153.5,
} as const;

/** Отступы между элементами внутри нотификации */
export const GAPS = {
    afterIcons: 4,
    afterText: 4,
    afterActionLabel: 4,
} as const;
